import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase/app";

import SignIn from "./views/SignIn.vue";
import SignUp from "./views/SignUp.vue";
import ResetPassword from "./views/ResetPassword.vue";
import Action from "./views/Action.vue";
import Dashboard from "./views/Dashboard.vue";
import Report from "./views/Report.vue";
import Profile from "./views/Profile.vue";
import ResultsPersonality from "./views/ResultsPersonality.vue";
import ResultsPathways from "./views/ResultsPathways.vue";
import TestPersonality from "./views/TestPersonality.vue";
import TestPathways from "./views/TestPathways.vue";
//import Debug from "./views/Debug.vue";

Vue.use(Router);

const router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/results/personality",
      name: "resultspersonality",
      component: ResultsPersonality,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/results/pathways",
      name: "resultspathways",
      component: ResultsPathways,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/report",
      name: "report",
      component: Report
    },
    {
      path: "/test/personality",
      name: "testpersonality",
      component: TestPersonality,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/test/pathways",
      name: "testpathways",
      component: TestPathways,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/sign-up",
      name: "signup",
      component: SignUp
    },
    {
      path: "/sign-in",
      name: "signin",
      component: SignIn
    },
    {
      path: "/reset-password/",
      name: "resetpassword",
      component: ResetPassword
    },
    {
      path: "/action/",
      name: "action",
      component: Action
    },
    /* {
      path: "/debug",
      name: "debug",
      component: Debug,
      meta: {
        requiresAuth: true
      }
    } */
  ]
  
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next("sign-in");
  } else {
    next();
  }
});

export default router;
